import React from 'react';
import PropTypes from 'prop-types';
import { AccordionsWrapper, AccordionHeading } from './styles';
import Accordion from './accordion';
import RichText from '../rich-text/base';

const Accordions = ({ accordionHeading, accordions }) => {
  if (!accordions) return null;

  return (
    <AccordionsWrapper>
      {accordionHeading ? (
        <AccordionHeading>{accordionHeading}</AccordionHeading>
      ) : null}
      {accordions.map(({ heading, content }, i) => (
        <Accordion header={heading} key={i} order={i + 1}>
          <RichText richText={content} />
        </Accordion>
      ))}
    </AccordionsWrapper>
  );
};

Accordions.propTypes = {
  accordionHeading: PropTypes.string,
  accordions: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      content: PropTypes.object,
    })
  ),
};

export default Accordions;

export const AccordionsAssembly = ({ contentfulData }) => (
  <Accordions
    accordionHeading={contentfulData.accordionHeading}
    accordions={contentfulData.accordions}
  />
);

AccordionsAssembly.propTypes = {
  contentfulData: PropTypes.object,
};
